import { gql } from '@apollo/client';

export const ADD_MODULES_TO_ORGANISATION = gql`
  mutation AddModulesToOrganisation($input: AddModulesInput!) {
    organisation: addModulesToOrganisation(input: $input) {
      id
    }
  }
`;
